import $ from 'jquery';

const changeAuthorizationVisibility = value => {
  const authorizationsElement = $('.users__course-authorizations');

  if (value === 'editor') {
    authorizationsElement.show();
  } else {
    authorizationsElement.hide();
  }
};

$('#user_role')
  .each((_index, el) => changeAuthorizationVisibility(el.value))
  .on('change', event => changeAuthorizationVisibility(event.target.value));
